import { AudioTranscriptSubtitleView } from '@modules/feedback/components/AudioType/AudioTranscriptPopper/AudioTranscriptSubtitleView';
import { trackAudioFeedbackEvents } from '@modules/feedback/components/AudioType/utils';
import { getAllHighlights } from '@modules/feedback/components/FeedbackDetails/utils';
import useFeedbackListStore from '@modules/feedback/store/useFeedbackListStore';
import { Highlight } from '@modules/feedback/types';
import { Box, alpha } from '@mui/material';
import { Feedback, FeedbackLabel } from 'v2/core/entities/feedback';

interface AudioTranscriptPreviewProps {
  feedback: Feedback;
  selectedLabels: FeedbackLabel[] | undefined;
  onExpandFeedbackDetails?: () => void;
}

export const AudioTranscriptPreview = ({
  feedback,
  selectedLabels,
  onExpandFeedbackDetails,
}: AudioTranscriptPreviewProps) => {
  const setIsTranscriptPopoverExpanded = useFeedbackListStore(
    (state) => state.setIsTranscriptPopoverExpanded,
  );

  const highlights: { [key: string]: Highlight[] } = selectedLabels?.length
    ? getAllHighlights(selectedLabels)
    : {};

  const handleExpand = () => {
    setIsTranscriptPopoverExpanded(true, feedback.id);
    onExpandFeedbackDetails?.();
    trackAudioFeedbackEvents({
      eventName: 'Audio Feedback - Transcript: Expanded To Full View',
      feedbackID: feedback.id,
    });
  };

  return (
    <Box px={2} pb={2}>
      <Box
        bgcolor={(theme) => alpha(theme.palette.background.paper, 0.6)}
        borderRadius={1}
      >
        <AudioTranscriptSubtitleView
          feedback={feedback}
          onExpand={handleExpand}
          highlights={highlights}
        />
      </Box>
    </Box>
  );
};
